<template>
	<!-- 运单信息-->
	<div class="saleCustomerManagement freight-info-page">
		<div class="public_Spacing customerManagementPC freight-info-shell">
			<div class="pulbic_oparetionBlock freight-filter-card">
				<div class="freight-section-head">
					<div>
						<div class="freight-section-title">运单信息</div>
						<div class="freight-section-subtitle">按发单人、手机号、装卸地和时间范围筛选运单</div>
					</div>
					<div class="freight-total-chip">共 {{ count || 0 }} 条</div>
				</div>
				<div class="public_criteriaRange customerManagementPC-select freight-filter-fields">
					<div class="public_oparetionBlock_Menu freight-filter-item">
						<label class="public_lbSty">发单人：</label>
						<div class="el-select public_optionSty">
							<div class="el-input el-input--suffix">
								<input style="padding-right: 10px;" maxlength="7"
									class="el-input__inner pulic_carNumber" type="text" placeholder="请输入客户名"
									v-model="cusQueryNameFD" @keyup.enter="page = 1; currentPage = 1; querycusList()" />
							</div>
						</div>
					</div>
					<div class="public_oparetionBlock_Menu freight-filter-item">
						<label class="public_lbSty">手机号：</label>
						<div class="el-select public_optionSty">
							<div class="el-input el-input--suffix">
								<input maxlength="11" class="el-input__inner pulic_carNumber" type="text"
									placeholder="请输入手机号" v-model="cusQueryiphone" @keyup.enter="page = 1; currentPage = 1; querycusList()" />
							</div>
						</div>
					</div>
					<div class="public_oparetionBlock_Menu freight-filter-item">
						<label class="public_lbSty">装货地：</label>
						<el-select class="public_optionSty dropDown_Define" @change="erpChange" v-model="enterpriseTwo"
							remote :remote-method="filterEnterprise" placeholder="请选择">
							<el-option v-for="item in filteredEnterpriseOptions" :key="item.SETTB99ID"
								:label="item.SETTB99CA00" :value="item.SETTB99ID">
							</el-option>
						</el-select>
					</div>
					<div class="public_oparetionBlock_Menu freight-filter-item">
						<label class="public_lbSty">卸货地：</label>
						<div class="el-select public_optionSty">
							<div class="el-input el-input--suffix">
								<input style="padding-right: 10px;" maxlength="7"
									class="el-input__inner pulic_carNumber" type="text" placeholder="请输入卸货地"
									v-model="unload" @keyup.enter="page = 1; currentPage = 1; querycusList()" />
							</div>
						</div>
					</div>
				</div>
					<div class="public_operatArea freight-toolbar">
						<span class="pulic_operatArea_now pulic_cursor freight-date-pill" :class="dateNowDayActive ? 'public_dateActive' : ''"
							@click="getNowDay" title="筛选当日运单">当日</span>
						<span class="public_operatArea_yesterday pulic_cursor freight-date-pill"
							:class="dateYesterdayActive ? 'public_dateActive' : ''" @click="getYesterday" title="筛选昨天运单">昨天</span>
						<span class="pulic_operatArea_now pulic_cursor freight-date-pill"
							:class="dateNowMonthActive ? 'public_dateActive' : ''" @click="sameMonth" title="筛选当月运单">当月</span>
						<span class="public_operatArea_yesterday pulic_cursor freight-date-pill"
							:class="dateLastMonthActive ? 'public_dateActive' : ''" @click="lastMonth" title="筛选上月运单">上月</span>
						<div class="public_operatArea_timePicker pulic_cursor freight-date-picker-wrap">
							<el-date-picker v-model="date" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
								range-separator="至" :picker-options="startDateDisabled" @change="datePickerChange"
								start-placeholder="开始日" end-placeholder="结束日" class="pulic_cursor freight-date-picker">
							</el-date-picker>
						</div>
						<div class="customerManagementPC-btn public_operatBtn freight-actions" style="margin-left: 0px;">
							<el-button class="public_saleWater_chaxun freight-query-btn" type="primary" v-shiroHiden="solelist" id="查询"
								@click="page = 1; currentPage = 1; querycusList()">
								<i class="iconfont icon-chaxun"></i>查询
							</el-button>

							<!-- <el-button class="public_saleWater_chaxun freight-query-btn" type="primary" v-shiroHiden="solelist" id="查询"
								@click="querycusList(1)">
								<i class="iconfont icon-chaxun"></i>查询全部
							</el-button> -->
						</div>
					</div>
			</div>
				<div class="billOperationRecord-table pulbic_table_container freight-table-card">
				<div class="freight-table-toolbar">
					<div>
						<div class="freight-section-title">运单列表</div>
						<div class="freight-section-subtitle">查看运单运费、车次数量和接单进度</div>
					</div>
					<div class="freight-table-badge">当前第 {{ currentPage }} 页</div>
				</div>
				<el-table :data="tableData" @sort-change="onSortChange" style="width: 100%" stripe highlight-current-row
					class="public_tableColumn freight-main-table"
					:header-cell-style="{ color: 'rgba(38,50,56,1)', background: 'rgba(232,246,255,1)', 'font-weight': 'bold' }">
					<template slot="empty">
						<div class="freight-empty">
							<div class="freight-empty-title">暂无运单信息</div>
							<div class="freight-empty-desc">可调整筛选条件后重新查询</div>
						</div>
					</template>
					<el-table-column prop="ORMTB460CA11" width="180" label="发单时间" class-name="freight-time-column"></el-table-column>
					<el-table-column prop="ORMTB460CA16" min-width="150" label="发单人">
						<template slot-scope="scope">
							<div class="freight-customer-cell">
								<div class="freight-primary-text">{{ scope.row.ORMTB460CA16 || '--' }}</div>
								<div class="freight-muted-text">{{ scope.row.ORMTB460CA15 || '--' }}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column min-width="220" label="运输线路">
						<template slot-scope="scope">
							<div class="freight-route-cell">
								<span class="freight-route-point">{{ scope.row.ORMTB460CA00 || '--' }}</span>
								<span class="freight-route-arrow">-></span>
								<span class="freight-route-point">{{ scope.row.ORMTB460CA01 || '--' }}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="ORMTB460CA26" width="112" label="发单运费">
						<template slot-scope="scope">
							<span class="freight-money">{{ scope.row.ORMTB460CA26 || '--' }}</span>
						</template>
					</el-table-column>
					<el-table-column width="200" label="车次进度">
						<template slot-scope="scope">
							<div class="freight-progress-cell">
								<div class="freight-progress-total">总 {{ scope.row.ORMTB460CA08 || 0 }} 车</div>
								<div class="freight-progress-chips">
									<span class="freight-progress-chip is-done">已接 {{ parseInt(scope.row.ORMTB460CA08 || 0) - parseInt(scope.row.ORMTB460CA10 || 0) }}</span>
									<span class="freight-progress-chip is-pending">未接 {{ scope.row.ORMTB460CA10 || 0 }}</span>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column width="90" label="运单类型">
						<template slot-scope="scope">
							<span v-if="scope.row.ORMTB460CA33 == 0" class="freight-type-tag freight-type-self">自发</span>
							<span v-else-if="scope.row.ORMTB460CA33 == 1" class="freight-type-tag freight-type-proxy">代发</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="172">
						<template slot-scope="scope">
							<div class="customerManagementPC-table-btn freight-action-group">
								<!-- <el-button @click="updateUserStatus(scope.row)" type="success"
									style="color: #67C23A!important" class="public_icon_xiugai public_icon_width"
									size="small">通过
								</el-button> -->
								<!-- <el-button @click="updateUserJJStatus(scope.row)" type="error"
									class="public_icon_xiugai public_icon_width" size="small"
									>修改</el-button>
									<el-button @click="updateUserJJStatusQX(scope.row)" type="error"
										style="color: red!important" class="public_icon_xiugai public_icon_width" size="small"
										>取消</el-button> -->
								<el-tooltip content="查看完整运单信息" placement="top" effect="light">
									<el-button @click="DetailsClick(scope.row)" type="primary"
										class="public_icon_xiugai public_icon_width freight-detail-btn" size="small"
										style="color: #409EFF!important">详情</el-button>
								</el-tooltip>
								<el-tooltip v-if="scope.row.ORMTB460CA10 > 0" content="取消未接车次" placement="top" effect="light">
									<el-button @click="cancelClick(scope.row)"
										type="primary" class="public_icon_xiugai public_icon_width freight-cancel-btn" size="small"
										style="color: rgb(255, 165, 0)!important">取消车次</el-button>
								</el-tooltip>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="customerManagementPC-page freight-pagination">
					<span style="font-size: 14px;color:#606266;" v-if="flag == '1'">共{{ count }}条</span>
					<el-pagination v-if="!flag" @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]"
						layout="total, sizes,prev, pager, next, jumper" :page-size="pagesize" :total="count"></el-pagination>
				</div>
			</div>
			<div class="public-dialog">
				<el-dialog title="运单信息" :visible.sync="oerderDetilsShow" width="45%" @close="detailsList = ''"
					:closeOnClickModal='false' append-to-body custom-class="freight-info-dialog">
					<div class="DetailsWater-Dialog freight-detail-grid">
						<div class="DWD-li">
							<div class="DWD-li-title">装货地</div>
							<div class="DWD-li-text">{{ shMasgObj.ORMTB460CA00 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">卸货地</div>
							<div class="DWD-li-text">{{ shMasgObj.ORMTB460CA21 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">车型</div>
							<div class="DWD-li-text">{{ shMasgObj.ORMTB460CA02 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">物料类型</div>
							<div class="DWD-li-text">{{ shMasgObj.ORMTB460CA06 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">物料单价</div>
							<div class="DWD-li-text">{{ shMasgObj.ORMTB460CA07 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">接单运费</div>
							<div class="DWD-li-text">{{ shMasgObj.ORMTB460CA09 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">发单运费</div>
							<div class="DWD-li-text">{{ shMasgObj.ORMTB460CA26 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">亏吨范围(吨)</div>
							<div class="DWD-li-text">{{ shMasgObj.ORMTB460CA25 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">超时取消时间(小时)</div>
							<div class="DWD-li-text">{{ shMasgObj.ORMTB460CA27 || '' }}</div>
						</div>
						<div class="DWD-li" v-if="userobj.pertb005.pertb005cb00 == 'CUS-1'">
							<div class="DWD-li-title">代发扣款账户</div>
							<div class="DWD-li-text">{{ shMasgObj.ORMTB410CA00 || '' }}</div>
						</div>
						<div class="DWD-li" v-if="userobj.pertb005.pertb005cb00 == 'CUS-1'">
							<div class="DWD-li-title">管理费</div>
							<div class="DWD-li-text">{{ shMasgObj.ORMTB460CA34 || 0 }}%</div>
						</div>
						<!-- <div class="DWD-li">
							<div class="DWD-li-title">厂家</div>
							<div class="DWD-li-text">{{shMasgObj.ORMTB460CA04||''}}</div>
						</div> -->
						<div class="DWD-li">
							<div class="DWD-li-title">运单类型</div>
							<div class="DWD-li-text" v-if="shMasgObj.ORMTB460CA33 == 0">自发</div>
							<div class="DWD-li-text" v-if="shMasgObj.ORMTB460CA33 == 1">代发</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">是否公开</div>
							<div class="DWD-li-text" v-if="shMasgObj.ORMTB460CA31 == '1'">不公开</div>
							<div class="DWD-li-text" v-if="shMasgObj.ORMTB460CA31 == '2'">公开</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">是否指定</div>
							<div class="DWD-li-text" v-if="shMasgObj.ORMTB460CA30 == '1'">指定</div>
							<div class="DWD-li-text" v-if="shMasgObj.ORMTB460CA30 == '2'">不指定</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">接单物料冻结</div>
							<div class="DWD-li-text" v-if="shMasgObj.ORMTB460CA32 == '0'">不冻结</div>
							<div class="DWD-li-text" v-if="shMasgObj.ORMTB460CA32 == '1'">冻结</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">已接单车号</div>
							<div class="DWD-li-text">{{ shMasgObj.used || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">未接单车号</div>
							<div class="DWD-li-text">{{ shMasgObj.unUse || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">发单时间</div>
							<div class="DWD-li-text">{{ shMasgObj.ORMTB460CA11 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">发单人</div>
							<div class="DWD-li-text">{{ shMasgObj.ORMTB460CA16 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">卸货净重</div>
							<div class="DWD-li-text">{{ shMasgObj.ORMTB460CA38 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">运费结算甩零方式</div>
							<div class="DWD-li-text">{{ shMasgObj.ORMTB460CA39 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">卸货时间</div>
							<div class="DWD-li-text">{{ shMasgObj.ORMTB460CA40 || '' }}</div>
						</div>
						<!-- <div class="DWD-li">
							<div class="DWD-li-title">运单类型</div>
							<div class="DWD-li-text">{{shMasgObj.ORMTB460CA01||''}}</div>
						</div> -->
						<!-- <div class="DWD-li">
							<div class="DWD-li-title">审核状态</div>
							<div class="DWD-li-text" v-if="shMasgObj.ORMTB469CD01==0">待审核</div>
							<div class="DWD-li-text" v-if="shMasgObj.ORMTB469CD01==1">通过</div>
							<div class="DWD-li-text" v-if="shMasgObj.ORMTB469CD01==2">拒绝</div>
							<div class="DWD-li-text" v-if="shMasgObj.ORMTB469CD01==3">取消</div>
						</div> -->
						<!-- <div class="DWD-li">
							<div class="DWD-li-title">申请备注</div>
							<div class="DWD-li-text">{{detailsList.ORMTB421CA04||''}}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">审核备注</div>
							<div class="DWD-li-text">
								<input type="text" v-model="isorderAuditText" maxlength="20">
							</div>
						</div> -->
					</div>
					<!-- <div class="DWD-li" style="height: 80px;color: #fff;" v-if="DetailsWaterurl!=''">
							<div class="DWD-li-title" style="height: 80px;line-height: 80px;color:#333 ;">凭证记录</div>
							<el-image v-for="(items,indexs) in DetailsWaterurl" :key="indexs"
								style="width: 80px; height: 80px" :src="items.url" :preview-src-list="DetailsWatersrcList">
							</el-image>
						</div>
						<div class="DWD-li" v-else>
							<div class="DWD-li-title">凭证记录</div>
							<div class="DWD-li-text"></div>
						</div> -->
				</el-dialog>
			</div>
			<!-- 取消车次弹窗 -->
			<div class="public-dialog">
				<el-dialog title="取消车次" :visible.sync="cancelClickShow" width="30%" :closeOnClickModal='false' append-to-body custom-class="freight-info-dialog">
					<div class="cancel_content">
						<el-form :model="formLabelAlign">
							<el-form-item label="总车数">
								<el-input v-model="formLabelAlign.name" :disabled="true"></el-input>
							</el-form-item>
							<el-form-item label="可取消车数">
								<el-input v-model="formLabelAlign.region" :disabled="true"></el-input>
							</el-form-item>
							<el-form-item label="取消车数">
								<el-input v-model="formLabelAlign.type" placeholder="请输入要取消的车数"></el-input>
							</el-form-item>
							<el-form-item style="text-align: center;">
								<el-button type="primary" @click="onCancelSubmit">确定</el-button>
								<el-button @click="cancelClickShow = false">取消</el-button>
							</el-form-item>
						</el-form>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
import {
	Decimal
} from 'decimal.js';
import enterpriseSearchMixin from '@/mixins/enterpriseSearchMixin'
export default {
  mixins: [enterpriseSearchMixin],
	data() {
		return {
			customerManagementList: '',
			customerManagementValue: '',
			customerManagement: false,
			customerManagementAdd: false,
			customerManagementAddName: '',
			customerManagemenUPObj: '',
			customerManagementUpdate: false,
			oerderDetilsShow: false,
			shMasgObj: {},
			cusQueryNameFD: '',
			cusQueryiphone: '',
			options: [],
			cusStatus: '',
			cusStatusList: [],
			tableData: [],
			flag: '',
			page: 1,
			pagesize: 10,
			currentPage: 1,
			count: 0,
			currentPage1: 1,
			detailsPageLimit: 10,
			detailsCount: 1,
			RechargetypeValue: '',
			RechargetypeOptions: [],
			CZRecordsDetails: [],
			CZRecordsPage: 1,
			CZRecordsPageLimit: 10,
			CZRecordsCount: 0,
			tableDataDetails: [],
			offerDetailsTab: [],
			ORMTB411ID: '',
			CustomerfillingDig: false,

			CZmoney: '',
			Czmaxlength: 10, //充值限额
			HCmoney: '',
			HCremark: '',
			HCamountCapitalText: '',
			amountCapitalText: '',
			cusInsertShow: false,
			cusInsertObj: {
				ORMTB400ID: '',
				ORMTB410CA00: '',
				ORMTB410CA01: '',
				ORMTB410CA02: '',
				ORMTB410CA06: ''
			},
			cusUpdateShow: false,
			cusUpdateObj: {
				ORMTB400ID: '',
				ORMTB410CA00: '',
				ORMTB410CA01: '',
				ORMTB410CA02: '',
				ORMTB410CA06: ''
			},
			saleWaterDetails: false,
			rechargeTypeDig: false,
			rechargeTypeName: '',
			rechargeTypeUpOBJ: {
				SETTB206CA01: ''
			},
			rechargeTypeModifyDig: false,
			czRechargetypeShow: false,
			HCshow: false,
			HCObj: '',
			preferentialRecord: false,
			offerDetails: false,
			DetailsWater: false,
			deductionRecord: false,
			deductionRecordObj: '',
			deductionRecordtable: [],
			deductionRecordPage: 1,
			deductionRecordLimit: 10,
			deductionRecordCount: 0,

			preferentialType: 0,
			solelist: [],
			xsZsrcList: [],
			xsFsrcList: [],
			jszsrcList: [],
			enterpriseTwoOptionList: [{
				SETTB109CA00: '全部',
				SETTB109ID: '',
			}], //二级企业下拉框--新增
			uobj: this.$store.state.uobj, //登陆缓存--用户信息
			enterpriseTwo: '',
			dress: '',//装货地
			unload: '',//卸货地
			cancelClickShow: false,
			formLabelAlign: {
				name: '',
				region: '',
				type: ''
			},
			date: [], //日期
			startTime: '',
			endTime: '',
			dateNowDayActive: false,
			dateYesterdayActive: false,
			dateNowMonthActive: false,
			dateLastMonthActive: false,
			twolevelUserLogin: true,
			timeIndex: 0, //判断第几次切换当月时间
			sameMonthTime: '', //目前月份
			currentMonthTime: '', //目前月份--上月+1
			startDateDisabled: {
				disabledDate(time) {
					return time.getTime() > Date.now()
				},
			},
			ORMTB460ID:'',
			ORMTB4101D:'',
		};
	},
	created() {
		var list = "";
		if (this.$route.query.mark != "" && this.$route.query.mark != null) {
			this.userobj = JSON.parse(sessionStorage.getItem("qpUobj"));
			list = JSON.parse(sessionStorage.getItem("qpSolelist"));
			sessionStorage.removeItem('qpUobj');
			sessionStorage.removeItem('qpSolelist');
			this.quanpDisabled = true;
		} else {
			this.userobj = this.$store.state.uobj;
			console.log(this.userobj)
			list = this.$store.state.solelist;
			this.quanpDisabled = false;
		}
		var path = this.$route.path;
		if (path === "/SalesFreightInformation") {
			path = "/Home" + path;
		}
		this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
		// // 赋值，缓存销毁
		this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl));
		sessionStorage.removeItem(this.currentUrl);
		if (this.historyInfo != null && this.historyInfo != "") {
			this.init();
		}
		// console.log(this.solelist)
	},
	mounted() {
		this.getNowDay()
		this.startTime = this.date[0]
      filteredEnterpriseOptions: [],
		this.endTime = this.date[1]
		this.dateNowDayActive = true
		this.loadEnterpriseOptions()
		this.querycusList()
		// this.querypreferentialCode()
	},
	// 存储数据
	beforeDestroy() {
		// var obj = {
		// 	cusQueryNameFD: this.cusQueryNameFD, //客户名称
		// 	cusQueryiphone: this.cusQueryiphone, //客户手机号
		// 	cusStatus: this.cusStatus, //客户状态
		// 	currentPage: this.currentPage, //当前页数
		// 	page: this.page, //页码
		// 	pagesize: this.pagesize, //每页条数
		// };
		// sessionStorage.setItem(this.currentUrl, JSON.stringify(obj));
	},
	methods: {
			loadEnterpriseOptions() {
				var postData = {
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
					type: 1
				}
				var List = [{ SETTB99ID: '', SETTB99CA00: '全部' }]
				this.axios.post('/set/settb100/selectSettb100ByCa02', postData).then(res => {
					if (res.data.code == 200) {
						this.enterpriseTwoOptionList = [...List, ...res.data.data]
						this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.slice(0, 100)
					} else {
						this.$message({ message: res.data.message, type: 'error' })
					}
				})
			},
		// 取消车次按钮
		cancelClick(row) {
			this.formLabelAlign.name = row.ORMTB460CA08;
			this.formLabelAlign.region = row.ORMTB460CA10;
			this.ORMTB460ID = row.ORMTB460ID;
			this.ORMTB410ID = row.ORMTB410ID;
			this.cancelClickShow = true;
		},
		onCancelSubmit() {
			if(this.formLabelAlign.type > this.formLabelAlign.region){
				return this.$message({
					message: '取消车数不能大于可取消车数',
					type: 'warning'
				});
			}
			if(this.formLabelAlign.type < 0 || this.formLabelAlign.type == 0){
				return this.$message({
					message: '取消车数必须大于0',
					type: 'warning'
				});
			}
			this.axios.post('orm/ormtb460/cancle460UnCar', {COUNT: this.formLabelAlign.type, ORMTB460ID: this.ORMTB460ID, ORMTB410ID: this.ORMTB410ID}).then(res => {
				if (res.data.code == 200) {
					this.$message({
						message: res.data.message,
						type: 'success'
					});
					this.cancelClickShow = false;
					this.querycusList();
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				loading.close();
			})
		},
		erpChange() {

		},
		dateFtt(fmt, date) {
			//author: meizz
			var o = {
				'M+': date.getMonth() + 1, //月份
				'd+': date.getDate(), //日
				'h+': date.getHours(), //小时
				'm+': date.getMinutes(), //分
				's+': date.getSeconds(), //秒
				'q+': Math.floor((date.getMonth() + 3) / 3), //季度
				S: date.getMilliseconds(), //毫秒
			}
			if (/(y+)/.test(fmt))
				fmt = fmt.replace(
					RegExp.$1,
					(date.getFullYear() + '').substr(4 - RegExp.$1.length)
				)
			for (var k in o)
				if (new RegExp('(' + k + ')').test(fmt))
					fmt = fmt.replace(
						RegExp.$1,
						RegExp.$1.length == 1
							? o[k]
							: ('00' + o[k]).substr(('' + o[k]).length)
					)
			return fmt
		},

		//获取当前时间
		getNowDay() {
			var date = new Date().getTime()
			var Ming = new Date().getTime() + 24 * 60 * 60 * 1000
			var data = this.dateFtt('yyyy-MM-dd', new Date(Ming))
			var enddata = this.dateFtt('yyyy-MM-dd', new Date(date))
			data = `${data} ${this.exchangeTiem || '00:00:00'}`
			enddata = `${enddata} ${this.exchangeTiem || '00:00:00'}`
			this.date = [enddata, data]
			this.dateNowDayActive = true
			this.dateYesterdayActive = false
			this.dateNowMonthActive = false
			this.dateLastMonthActive = false
		},
		datePickerChange(e) {
			this.dateNowDayActive = false
			this.dateYesterdayActive = false
			this.dateNowMonthActive = false
			this.dateLastMonthActive = false
		},
		//获取昨天时间
		getYesterday() {
			var hms = new Date().getTime() - 24 * 60 * 60 * 1000
			var Ming = new Date().getTime()
			var nowDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
			var enddata = this.dateFtt('yyyy-MM-dd', new Date(Ming))
			nowDay = `${nowDay} ${this.exchangeTiem || '00:00:00'}`
			enddata = `${enddata} ${this.exchangeTiem || '00:00:00'}`
			this.date = [nowDay, enddata]
			this.dateNowDayActive = false
			this.dateYesterdayActive = true
			this.dateNowMonthActive = false
			this.dateLastMonthActive = false
		},
		//获取当月时间
		sameMonth() {
			var date = new Date()
			var hms = date.setDate(1)
			var firstDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
			firstDay = `${firstDay} ${this.exchangeTiem || '00:00:00'}`
			var nextdate = new Date().getTime() + 24 * 60 * 60 * 1000
			var nextDay = this.dateFtt('yyyy-MM-dd', new Date(nextdate))
			nextDay = `${nextDay} ${this.exchangeTiem || '00:00:00'}`
			this.date = [firstDay, nextDay]
			this.startTime = this.date[0]
			this.endTime = this.date[1]
			this.dateNowDayActive = false
			this.dateYesterdayActive = false
			this.dateNowMonthActive = true
			this.dateLastMonthActive = false
		},
		//获取上月时间
		lastMonth() {
			var nowdays = new Date()
			var year = nowdays.getFullYear()
			var month = nowdays.getMonth()
			var lastyear = year
			var lastmonth = month
			if (month == 0) {
				month = 12
				year = year - 1
			}
			if (month == 12) {
				lastmonth = 1
			} else {
				lastmonth = lastmonth + 1 * 1
			}
			if (month < 10) {
				month = '0' + month
			}
			if (lastmonth < 10) {
				lastmonth = '0' + lastmonth
			}
			var firstDayOfPreMonth = year + '-' + month + '-' + '01'
			var firstDayOfPreMonth = `${year}-${month}-01 ${this.exchangeTiem ||
				'00:00:00'}`
			// var lastDay = new Date(lastyear, lastmonth, 0);
			let lastDayOfPreMonth = `${lastyear}-${lastmonth}-01 ${this
				.exchangeTiem || '00:00:00'}`
			this.date = [firstDayOfPreMonth, lastDayOfPreMonth]
			this.dateNowDayActive = false
			this.dateYesterdayActive = false
			this.dateNowMonthActive = false
			this.dateLastMonthActive = true
		},
		onSortChange({
			prop,
			order
		}) {
			// console.log(order)
			if (prop == 'ORMTB410CA06') {
				this.tableData.sort(this.compare(prop, order));
			}

		},
		compare(propertyName, sort) {
			return function (obj1, obj2) {
				var value1 = obj1[propertyName];
				var value2 = obj2[propertyName];
				// console.log(value2)

				if (typeof value1 === "string" && typeof value2 === "string") {
					const res = value1.localeCompare(value2);
					return sort === "ascending" ? res : -res;
				} else {
					// if (value1 <= value2) {
					// 	return sort === "ascending" ? -1 : 1;
					// } else if (value1 > value2) {
					// 	return sort === "ascending" ? 1 : -1;
					// }
				}
			};
		},

		// 详情
		DetailsClick(row) {
			console.log(row)
			this.oerderDetilsShow = true;
			this.shMasgObj = row
			// this.querydetileTX(row)
		},

		//修改配送地址
		updateUserJJStatus(item) {
			// console.log(item)
			var url = "/orm/ormtb460/update"
			this.$prompt('请输入配送地', '配送地修改', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputPattern: /^.{1,}$/,
				inputValue: item.ORMTB460CA01,
				inputErrorMessage: '内容不能为空'
			}).then(({
				value
			}) => {
				var postData = {
					ORMTB460ID: item.ORMTB460ID,
					ORMTB460CA01: value
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message({
							message: res.data.message,
							type: 'success'
						});
						this.querycusList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			})
		},

		//取消车数
		updateUserJJStatusQX(item) {
			// console.log(item)
			var url = "/orm/ormtb460/cancelORMTB460"
			this.$prompt('请输入需要取消的车数', '取消车数', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputPattern: /^.{1,}$/,
				// inputValue:item.ORMTB460CA01,
				inputErrorMessage: '内容不能为空'
			}).then(({
				value
			}) => {
				var postData = {
					ORMTB460ID: item.ORMTB460ID,
					COUNT: value
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message({
							message: res.data.message,
							type: 'success'
						});
						this.querycusList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			})
		},


		updateUserJJYYStatus(item) {
			// console.log(item)
			var url = "/orm/ormtb450/updateORMTB450CA10"
			this.$alert(item.ORMTB450CA17, '拒绝原因', {
				confirmButtonText: '确定',
				callback: action => {

				}
			});
		},
		// 通过
		updateUserStatus(item) {
			var url = "/orm/ormtb450/updateORMTB450CA10"

			// console.log(item)
			var postData = {
				ORMTB450CA10: 1,
				ORMTB450ID: item.ORMTB450ID
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.querycusList()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})

		},



		//初始化数据
		init() {
			this.startTime = this.historyInfo.startTime
			this.endTime = this.historyInfo.endTime
			this.date = [this.startTime, this.endTime]
			this.cusQueryNameFD = this.historyInfo.cusQueryNameFD;
			this.cusQueryiphone = this.historyInfo.cusQueryiphone;
			this.currentPage = this.historyInfo.currentPage;
			this.page = this.historyInfo.page;
			this.pagesize = this.historyInfo.pagesize;
			this.cusStatus = this.historyInfo.cusStatus
			this.dateNowDayActive = this.historyInfo.dateNowDayActive
			this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
			this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
			this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
		},
		fullScreen() {
			//全屏
			var mark = 1;
			sessionStorage.setItem(
				"qpSolelist",
				JSON.stringify(this.$store.state.solelist)
			);
			sessionStorage.setItem("qpUobj", JSON.stringify(this.$store.state.uobj));

			let Logistics = this.$router.resolve({
				path: "/SalesCustomer",
				query: {
					mark: mark,
				},
			});
			this.$baseAPI.requestFullScreen(Logistics);
		},
		querycusList() {
			this.startTime = this.date[0]
			this.endTime = this.date[1]
			this.tableData = []
			var url = "/orm/ormtb460/selectPageList"

			var postData = {
				// ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
				ORMTB460CA16: this.cusQueryNameFD, //客户名称
				ORMTB460CA15: this.cusQueryiphone, //手机号
				ORMTB460CA03: this.enterpriseTwo,
				ORMTB460CA01: this.unload,
				page: this.page,
				limit: this.pagesize,
				startTime: this.startTime, //开始时间
				endTime: this.endTime, //结束时间
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.tableData = res.data.data;
					this.count = res.data.count;
					this.tableData.forEach((item) => {
						this.xsZsrcList.push(item.ORMTB450CA01);
						this.xsFsrcList.push(item.ORMTB450CA02);
						this.jszsrcList.push(item.ORMTB450CA08);
					});
				}
				if (this.tableData.length > 0) {
					setTimeout(() => {
						loading.close()
					}, 300)
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)

			}).catch(() => {
				loading.close()
			})
		},
		handleSizeChange(val) {
			this.pagesize = val;
			this.page = 1;
			this.querycusList();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.querycusList();
		},
		CZrecordClick(row) {
			// console.log(row)
			this.preferentialRecord = true
			var str = JSON.stringify(row)
			this.cusUpdateObj = JSON.parse(str)
			this.CZrecordQuery()
		},
		CZrecordQuery() {
			this.CZRecordsDetails = []
			// this.CZRecordsCount =0
			var url = "/orm/ormtb411/selectPageList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB410ID: this.cusUpdateObj.ORMTB410ID,
				page: this.CZRecordsPage,
				limit: this.CZRecordsPageLimit
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.CZRecordsDetails = res.data.data;
					this.CZRecordsCount = res.data.count;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		offerDetailsClick(row) {
			this.offerDetails = true
			this.offerDetailsTab = []
			var url = "/orm/ormtb412/selectList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB411ID: row.ORMTB411ID,
				SETTB206CD01: this.userobj.pertb005.pertb005cd01,
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.offerDetailsTab = res.data.data;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		deductionRecordClick(row) {
			this.deductionRecordtable = []
			// this.deductionRecordCount=0
			var url = "/orm/ormtb413/selectPageList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.ORMTB411ID = row.ORMTB411ID
			var postData = {
				ORMTB411ID: this.ORMTB411ID,
				page: this.deductionRecordPage,
				limit: this.deductionRecordLimit
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.deductionRecordtable = res.data.data;
					this.deductionRecordCount = res.data.count
					this.deductionRecordtable.forEach(item => {
						if (item.ORMTB413CA02 == 'KK') {
							item.ORMTB413CA02Text = "扣款"
						} else if (item.ORMTB413CA02 == 'TK') {
							item.ORMTB413CA02Text = "退款"
						}
					})
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		deductionRecordSizeChange(val) {
			this.deductionRecordLimit = val;
			this.deductionRecordPage = 1;
			this.deductionRecordClick();
		},
		deductionRecordCurrentChange(val) {
			this.deductionRecordPage = val;
			this.deductionRecordClick();
		},
		queryWayTypeQuery() {
			this.tableDataDetails = []
			// this.detailsCount=0
			var url = "/set/settb206/selectPageList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03,
				SETTB205ID: '01',
				page: this.currentPage1,
				limit: this.detailsPageLimit
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.tableDataDetails = res.data.data;
					this.detailsCount = res.data.count
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		handleSizeChange1(val) {
			this.detailsPageLimit = val;
			this.currentPage1 = 1;
			this.deductionRecordClick();
		},
		handleCurrentChange1(val) {
			this.currentPage1 = val;
			this.deductionRecordClick();
		},
		saleWaterDetailsclose() {

		},
		CustomerfillingDigClose() {

		},
		cusInsertClose() {
			this.cusInsertObj = {
				ORMTB400ID: '',
				ORMTB410CA00: '',
				ORMTB410CA01: '',
				ORMTB410CA02: '',
				ORMTB410CA06: ''
			}
		},

		upCusClose() {
			this.cusUpdateObj = {
				ORMTB400ID: '',
				ORMTB410CA00: '',
				ORMTB410CA01: '',
				ORMTB410CA02: '',
				ORMTB410CA06: ''
			}
			this.CZmoney = ''
			this.wayTypeValue = 'CW'
			this.amountCapitalText = ''
		},
		CZTypeQuery() {
			this.RechargetypeOptions = []
			var url = "/orm/ormtb411/selectCzType/" + this.userobj.ormtb400.ORMTB400CA03
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.get(url).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.RechargetypeOptions = res.data.data
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		czClick(row) { //点击充值
			this.CustomerfillingDig = true
			var str = JSON.stringify(row)
			this.cusUpdateObj = JSON.parse(str)
			this.CZTypeQuery()
		},
		CZserve() {
			if (this.RechargetypeValue == '') return this.$message.error('请选择充值类型')
			if (this.wayTypeValue == '') return this.$message.error('请选择变动方式')
			if (this.CZmoney <= 0) return this.$message.error('请输入充值金额')
			var url = "/orm/ormtb411/cz"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB410ID: this.cusUpdateObj.ORMTB410ID,
				ORMTB420CA01: this.wayTypeValue,
				ORMTB420CA02: this.CZmoney,
				ORMTB411CA04: this.RechargetypeValue
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('充值成功')
					this.querycusList()
					this.CustomerfillingDig = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		HCclick(row) { //点击红值
			var str = JSON.stringify(row)
			this.cusUpdateObj = JSON.parse(str)
			this.HCshow = true
		},

		HCserve() {
			if (!this.HCmoney) return this.$message.error('请输入红冲金额');
			if (!this.HCremark) return this.$message.error('请输入备注');
			// if (this.HCmoney > this.cusUpdateObj.ORMTB410CA03) return this.$message.error('红冲金额不可大于余额');
			var url = "/orm/ormtb411/hc"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB410ID: this.cusUpdateObj.ORMTB410ID,
				ORMTB420CA02: this.HCmoney,
				ORMTB420CA08: this.HCremark
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success(`红冲成功`)
					this.HCshow = false
					this.querycusList()
					this.HCremark = ''
					this.HCmoney = ''
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		upuserClick(row) {
			if (this.preferentialType == 1) {
				this.customerManagementQuery()
			}
			this.cusUpdateShow = true
			var str = JSON.stringify(row)
			this.cusUpdateObj = JSON.parse(str)
		},
		cusADD() {
			if (this.preferentialType == 1) {
				this.customerManagementQuery()
			}
			this.cusInsertShow = true
		},
		cusUpdateServe() {
			if (this.cusUpdateObj.ORMTB410CA00.trim().length == 0) return this.$message.error('请输入客户名称')
			var reQ = /^1[3-9][0-9]{9}$/;
			if (!reQ.test(this.cusUpdateObj.ORMTB410CA02)) return this.$message.error('请输入有效手机号')
			if (this.preferentialType == 1) {
				if (this.cusUpdateObj.ORMTB410CA06.length == 0) {
					return this.$message.error('请选择客户等级')
				}
			}
			var url = "/orm/ormtb410/updateOrmtb410ById"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = this.cusUpdateObj
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('修改成功')
					this.querycusList()
					this.cusUpdateShow = false
					this.cusUpdateObj = {
						ORMTB400ID: '',
						ORMTB410CA00: '',
						ORMTB410CA01: '',
						ORMTB410CA02: '',
						ORMTB410CA06: ''
					}
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		rechargeTypeModify(row) {
			this.rechargeTypeModifyDig = true
			var str = JSON.stringify(row)
			this.rechargeTypeUpOBJ = JSON.parse(str)
		},
		disableCus(row, type) {
			var str = type == 1 ? '启用' : '禁用'
			this.$confirm(`此操作将${str}该条数据, 是否继续?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				var url = "/orm/ormtb410/updataCzType"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// console.log(this.userobj)
				var postData = {
					SETTB206CA01: '',
					SETTB206ID: row.SETTB206ID,
					SETTB206CA02: type,
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success(`${str}成功`)
						this.queryWayTypeQuery()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			})
		},
		rechargeTypeAdd() {
			this.rechargeTypeDig = true
		},
		rechargeTypeModifyClose() {
			this.rechargeTypeUpOBJ = {
				SETTB206CA01: ''
			}
		},
		querypreferentialCode() {
			var url = "/set/settb206/selectSETTB206List "
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				"SETTB205ID": "02", //默认02
				"SETTB206CA00": "0202", //代码值默认0202
				"SETTB206CD01": this.userobj.ormtb400.ORMTB400CA03 //一级客户代码
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.preferentialType = res.data.data[0].SETTB206CA02
					// 	loading.close()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		customerManagementQuery() {
			this.customerManagementList = []
			var url = "/set/settb206/selectPerson/" + this.userobj.ormtb400.ORMTB400CA03
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.get(url).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.customerManagementList = res.data.data
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		customerManagementAddServe() {
			if (this.customerManagementAddName.trim().length == 0) return this.$message.error('请输入名称')
			var url = "/set/settb206/insertVIP "
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				SETTB206CA01: this.customerManagementAddName,
				SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03,
				ORMTB400ID: this.userobj.ormtb400.ORMTB400ID
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('新增成功')
					this.customerManagementQuery()
					this.customerManagementAdd = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		cusUpdataClick(row) {
			this.customerManagemenUPObj = row
			this.customerManagemenUPObj.oldname = row.SETTB206CA01
			this.customerManagementUpdate = true
		},
		customerManagementUpdateServe() {
			if (this.customerManagemenUPObj.oldname == this.customerManagemenUPObj.SETTB206CA01)
				return this.$message
					.error('请修改名称')
			if (this.customerManagemenUPObj.SETTB206CA01.trim().length == 0) return this.$message.error(
				'请输入名称')
			var url = "/set/settb206/updateVIP"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB206CA01: this.customerManagemenUPObj.SETTB206CA01,
				SETTB206ID: this.customerManagemenUPObj.SETTB206ID,
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('修改成功')
					this.customerManagementQuery()
					this.customerManagementUpdate = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		rechaTypePreser() {
			if (this.rechargeTypeName.trim().length == 0) return this.$message.error('请输入名称')
			var url = "/orm/ormtb410/addCzType"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				SETTB206CA01: this.rechargeTypeName,
				SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('新增成功')
					this.queryWayTypeQuery()
					this.rechargeTypeDig = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		rechaTypePreserModify() {
			if (this.rechargeTypeUpOBJ.SETTB206CA01.trim().length == 0) return this.$message.error('请输入名称')
			var url = "/orm/ormtb410/updataCzType"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				SETTB206CA01: this.rechargeTypeUpOBJ.SETTB206CA01,
				SETTB206ID: this.rechargeTypeUpOBJ.SETTB206ID,
				SETTB206CA02: this.rechargeTypeUpOBJ.SETTB206CA02,
				SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('修改成功')
					this.queryWayTypeQuery()
					this.rechargeTypeModifyDig = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		DetailsWaterClick(item) {
			// console.log(item)
			if (!item.ORMTB440CA00) {
				this.$message({
					message: '未查询到订单',
					type: 'error'
				});
				return
			}
			this.DetailsWater = true
			this.deductionRecordDetileQuery(item)
		},
		deductionRecordDetileQuery(row) {
			this.deductionRecordObj = ''
			this.DetailsWatersrcList = []
			this.DetailsWaterurl = ''
			var url = "/orm/ormtb440/selectDetails"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				ORMTB440ID: row.ORMTB413CA03,
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.deductionRecordObj = res.data.data
					this.DetailsWatersrcList = [this.deductionRecordObj.ORMTB440CE01]
					this.DetailsWaterurl = this.deductionRecordObj.ORMTB440CE01
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		CZRecordsSizeChange(val) {
			this.pagesize = val;
			this.page = 1;
			this.CZrecordQuery();
		},
		CZRecordsCurrentChange(val) {
			this.page = val;
			this.CZrecordQuery();
		},

		HCMoneyInput() {
			this.HCmoney = this.HCmoney.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
			this.HCmoney = this.HCmoney.replace(/^\./g, ""); //验证第一个字符是数字
			this.HCmoney = this.HCmoney.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
			this.HCmoney = this.HCmoney.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			this.HCmoney = this.HCmoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
			if (this.HCmoney.indexOf(".") < 0 && this.HCmoney !=
				"") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
				this.HCmoney = parseFloat(this.HCmoney);
			}
			this.HCmoney = this.HCmoney > 10000000 ? 10000000 : this.HCmoney
			this.$refs.HCmoney.value = this.HCmoney
			this.HCamountCapitalText = this.priceChange(this.HCmoney)
		},
		HCMoneyChange() {
			var index = String(this.HCmoney).indexOf('.')
			if (index == -1) return
			var numArr = this.HCmoney.split('.')
			if (numArr[1].length == 0) {
				this.$refs.HCmoney.value = numArr[0]
				this.HCmoney = numArr[0]
			} else {
				this.$refs.HCmoney.value = numArr[0] + '.' + numArr[1]
				this.HCmoney = numArr[0] + '.' + numArr[1]
			}
		},
		topMoneyInput() { //充值金额实时校验
			this.CZmoney = this.CZmoney.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
			this.CZmoney = this.CZmoney.replace(/^\./g, ""); //验证第一个字符是数字
			this.CZmoney = this.CZmoney.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
			this.CZmoney = this.CZmoney.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			this.CZmoney = this.CZmoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
			if (this.CZmoney.indexOf(".") < 0 && this.CZmoney !=
				"") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
				this.CZmoney = parseFloat(this.CZmoney);
			}
			this.CZmoney = this.CZmoney > 10000000 ? 10000000 : this.CZmoney
			this.$refs.topMoney.value = this.CZmoney
			this.amountCapitalText = this.priceChange(this.CZmoney)
		},
		priceChange(number) {
			var ret = "";
			if (number != "" && number != null && number != "0") {
				var unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
					str = "";
				number += "00";
				var point = number.indexOf(".");
				if (point >= 0) {
					number = number.substring(0, point) + number.substr(point + 1, 2);
				}
				unit = unit.substr(unit.length - number.length);
				for (var i = 0; i < number.length; i++) {
					str += "零壹贰叁肆伍陆柒捌玖".charAt(number.charAt(i)) + unit.charAt(i);
				}
				ret =
					str
						.replace(/零(仟|佰|拾|角)/g, "零")
						.replace(/(零)+/g, "零")
						.replace(/零(万|亿|元)/g, "$1")
						.replace(/(亿)万|(拾)/g, "$1$2")
						.replace(/^元零?|零分/g, "")
						.replace(/元$/g, "元");
			}
			return ret;
		},
		topMoneyChange() { //充值金额失去焦点数据处理
			var index = String(this.CZmoney).indexOf('.')
			if (index == -1) return
			var numArr = this.CZmoney.split('.')
			if (numArr[1].length == 0) {
				this.$refs.topMoney.value = numArr[0]
				this.CZmoney = numArr[0]
			} else {
				this.$refs.topMoney.value = numArr[0] + '.' + numArr[1]
				this.CZmoney = numArr[0] + '.' + numArr[1]
			}
		},
	}
};
</script>

<style scoped>
.carDialogTitle {
	font-weight: bold;
	line-height: 60px;
	color: rgb(0, 163, 255);
}

.customerManagementPC {
	background-color: #f3f3f3;
}

.DWD-li {
	display: flex;
	height: 35px;
	line-height: 35px;
	box-sizing: border-box;
	border: 1px solid #999;
	font-size: 16px;
	color: #333;
}

.DWD-li>div {
	padding: 0 5px;
	height: 34px;
	overflow: hidden;
	box-sizing: border-box;
}

.DWD-li-title {
	width: 150px;
	text-align: center;
	border-right: 1px solid #999;
	background-color: rgba(0, 163, 255, .1);
}

.DWD-li+.DWD-li {
	border-top: none;
}

.DWD-table {
	display: flex;
}

.DWD-table-left-flex {
	flex: 1;
}

.DWD-table>div>div {
	padding: 0 5px;
	height: 35px;
	line-height: 35px;
	overflow: hidden;
	text-align: center;
	border-right: 1px solid #999;
	border-bottom: 1px solid #999;
	box-sizing: border-box;
}

.DWD-table>div>div:first-child {
	background-color: rgba(0, 163, 255, .1);
}

.DWD-table-left-title>div {
	width: 101px;
	text-align: center;
	background-color: rgba(0, 163, 255, .1);
}

.DWD-table .DWD-table-left-title>div {
	padding: 0 5px;
	height: 35px;
	line-height: 35px;
	overflow: hidden;
	box-sizing: border-box;
	border-left: 1px solid #999;
	border-bottom: 1px solid #999;
}

.DetailsWater-img {
	margin-top: 30px;
}

.DetailsWater-img-text {
	display: inline-block;
	width: 101px;
	text-align: center;
	vertical-align: top;
}

.customerManagementPC-select .public_oparetionBlock_Menu:first-child {
	margin-left: 0;
}

.customerManagementPC-btn {
	text-align: left;
	margin-bottom: 20px;
}

.customerManagementPC-btn i {
	margin-right: 10px;
}

.customerManagementPC-table {
	padding: 30px 20px 0;
}

.customerManagementPC-table-btn i {
	font-size: 12px;
	margin-right: 5px;
}

.public-chech-details-table {
	margin-top: 20px;
	max-height: 500px;
	overflow-y: auto;
}

.public-chech-details-table-no-text {
	line-height: 80px;
	text-align: center;
	border-bottom: 1px solid #cdcdcd;
}

.customerManagementPC-page {
	margin-top: 20px;
	text-align: right;
}

.CustomerfillingDig-priceNumtext {
	font-weight: 500;
	font-size: 18px;
	line-height: 40px;
	padding: 20px 0 20px 10px;
	color: #333;
}

.CustomerfillingDig-priceNumtext span {
	color: rgba(175, 181, 4, 1.0);
	margin-left: 10px;
	font-size: 20px;
}

.fontBlue {
	color: rgba(25, 159, 255, 1) !important;
}

.billOperationRecord {
	background-color: #f3f3f3;
}

.billOperationRecord-border {

	/* border-top: 2px solid rgba(205,205,205,.4); */
	border-top: none;
	box-sizing: border-box;
	margin-right: 40px;
}

.billOperationRecord th,
.billOperationRecord td {
	text-align: center;
}

.customerRecharge-table {
	box-sizing: border-box;
}

.CustomertopUpDig-content-table-btn>.public_saleWater_lieSet {
	border-color: rgba(254, 172, 0, 1) !important;
}

.billOperationRecord-page {
	padding-right: 40px;
	text-align: right;
	margin-top: 20px;
	padding-bottom: 20px;
}

.salesWatersStatisticsPC-saleWaterDetails-btn {
	margin-bottom: 20px;
}

.salesWatersStatisticsPC-saleWaterDetails-btn i {
	margin-right: 10px;
}

.el-dropdown-link {
	cursor: pointer;
}

.el-table--scrollable-y .el-table__body-wrapper {
	overflow: auto;
}

.public_tableColumn .el-table__body-wrapper {
	overflow: auto !important;
}

.public_icon_width {
	width: 80px;
}

.cancel_content /deep/.el-form-item {
	display: flex;
}

.cancel_content /deep/.el-form-item__label {
	width: 100px !important;
}

.cancel_content /deep/.el-form-item__content {
	flex: 1;
	margin-left: 0 !important;
}
.freight-info-page {
	min-height: 100%;
	padding: 14px;
	background:
		linear-gradient(135deg, rgba(25, 159, 255, .08) 0%, rgba(32, 218, 156, .08) 34%, rgba(245, 249, 252, 0) 70%),
		linear-gradient(180deg, #eef8ff 0%, #f6fafc 42%, #f3f6f8 100%);
	box-sizing: border-box;
}

.freight-info-shell {
	background: transparent;
}

.freight-filter-card,
.freight-table-card {
	position: relative;
	border: 1px solid rgba(25, 159, 255, .16);
	border-radius: 16px;
	background: linear-gradient(180deg, rgba(255, 255, 255, .98), rgba(250, 253, 255, .96));
	box-shadow: 0 12px 30px rgba(34, 90, 132, .1);
	box-sizing: border-box;
	transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease;
}

.freight-filter-card:hover,
.freight-table-card:hover {
	border-color: rgba(25, 159, 255, .28);
	box-shadow: 0 18px 38px rgba(34, 90, 132, .14);
	transform: translateY(-1px);
}

.freight-filter-card {
	margin-bottom: 20px;
	padding: 16px;
	border-color: rgba(25, 159, 255, .2);
	background:
		linear-gradient(120deg, rgba(25, 159, 255, .1), rgba(32, 218, 156, .06) 38%, rgba(255, 255, 255, .98) 39%),
		#fff;
	box-shadow: 0 10px 26px rgba(34, 90, 132, .09);
}

.freight-filter-card::before {
	content: '';
	position: absolute;
	left: 0;
	top: 16px;
	bottom: 16px;
	width: 4px;
	border-radius: 0 999px 999px 0;
	background: linear-gradient(180deg, #199fff, #20da9c);
}

.freight-table-card {
	padding: 18px;
	border-color: rgba(32, 139, 198, .2);
	background:
		linear-gradient(180deg, rgba(255, 255, 255, .99), rgba(247, 252, 255, .96)),
		#fff;
	box-shadow: 0 18px 42px rgba(34, 90, 132, .14);
}

.freight-table-card::before {
	content: '';
	position: absolute;
	left: 0;
	top: 16px;
	bottom: 16px;
	width: 4px;
	border-radius: 0 999px 999px 0;
	background: linear-gradient(180deg, #20da9c, #199fff);
}

.freight-section-head,
.freight-table-toolbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	margin-bottom: 14px;
	padding-bottom: 10px;
	border-bottom: 1px dashed rgba(25, 159, 255, .14);
}

.freight-table-toolbar {
	margin-top: 4px;
	padding-left: 12px;
	padding-right: 12px;
	box-sizing: border-box;
}

.freight-section-title {
	position: relative;
	padding-left: 12px;
	color: #263238;
	font-size: 18px;
	font-weight: 700;
	line-height: 25px;
}

.freight-section-title::before {
	content: '';
	position: absolute;
	left: 0;
	top: 5px;
	width: 4px;
	height: 14px;
	border-radius: 4px;
	background: linear-gradient(180deg, #199fff, #20da9c);
}

.freight-section-subtitle {
	margin-top: 3px;
	color: #7a8b96;
	font-size: 14px;
	line-height: 20px;
}

.freight-total-chip,
.freight-table-badge {
	flex-shrink: 0;
	padding: 6px 12px;
	border-radius: 999px;
	background: #eaf7ff;
	color: #1685d9;
	font-size: 14px;
	font-weight: 700;
}

.freight-filter-fields {
	display: grid;
	grid-template-columns: repeat(4, minmax(180px, 1fr));
	gap: 12px;
	align-items: end;
	margin-bottom: 12px;
	padding: 14px;
	border: 1px solid #dbeef9;
	border-radius: 12px;
	background: rgba(255, 255, 255, .82);
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, .9), 0 6px 16px rgba(34, 90, 132, .05);
	transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
}

.freight-filter-fields:hover,
.freight-toolbar:hover {
	border-color: #c7e4f5;
	background: rgba(255, 255, 255, .94);
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, .95), 0 9px 20px rgba(34, 90, 132, .07);
}

.freight-filter-item {
	display: flex;
	align-items: center;
	margin: 0 !important;
	min-width: 0;
	transition: transform .2s ease;
}

.freight-filter-item:focus-within {
	transform: translateY(-1px);
}

.freight-filter-item:focus-within .public_lbSty {
	color: #1685d9;
}

.freight-filter-item .public_lbSty {
	flex: 0 0 64px;
	color: #52636f;
	font-weight: 700;
}

.freight-filter-item .public_optionSty,
.freight-filter-item .el-select {
	flex: 1;
	min-width: 0;
}

.freight-toolbar {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px;
	margin: 0;
	padding: 12px 14px;
	border: 1px solid #dbeef9;
	border-radius: 12px;
	background: rgba(255, 255, 255, .88);
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, .9), 0 6px 16px rgba(34, 90, 132, .05);
	transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
}

.freight-date-pill {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 58px;
	height: 34px;
	margin: 0 !important;
	border: 1px solid #d8eaf6;
	border-radius: 999px;
	background: #f7fbfe;
	color: #55707f;
	font-size: 14px;
	font-weight: 700;
	transition: all .2s ease;
}

.freight-date-pill:hover,
.freight-toolbar .public_dateActive {
	border-color: transparent;
	background: linear-gradient(135deg, #199fff, #20da9c) !important;
	color: #fff !important;
	box-shadow: 0 8px 18px rgba(25, 159, 255, .22);
	transform: translateY(-1px);
}

.freight-date-picker-wrap {
	margin: 0 !important;
}

.freight-actions {
	margin: 0 0 0 auto !important;
	display: flex;
	align-items: center;
	gap: 8px;
}

.freight-actions::before {
	content: 'Enter 快速查询';
	padding: 5px 10px;
	border: 1px solid #d8eaf6;
	border-radius: 999px;
	background: #f7fbfe;
	color: #78909c;
	font-size: 12px;
	font-weight: 700;
}

.freight-query-btn {
	height: 34px;
	padding: 0 18px;
	border: none !important;
	border-radius: 999px;
	background: linear-gradient(135deg, #199fff, #20da9c) !important;
	box-shadow: 0 8px 18px rgba(25, 159, 255, .2);
	font-weight: 700;
	transition: transform .2s ease, box-shadow .2s ease, filter .2s ease;
}

.freight-query-btn:hover,
.freight-query-btn:focus {
	box-shadow: 0 12px 24px rgba(25, 159, 255, .28);
	filter: brightness(1.03);
	transform: translateY(-1px);
}

.freight-query-btn:active {
	box-shadow: 0 6px 14px rgba(25, 159, 255, .2);
	transform: translateY(0);
}

.freight-main-table {
	overflow: hidden;
	border: 1px solid #d2e8f4;
	border-radius: 14px;
	background: #fff;
	box-shadow: 0 10px 24px rgba(34, 90, 132, .08), inset 0 1px 0 rgba(255, 255, 255, .8);
}

.freight-info-page ::v-deep .freight-main-table .el-table__cell {
	padding: 6px 0;
}

.freight-info-page ::v-deep .freight-main-table th.el-table__cell {
	border-bottom: 1px solid #b5dced;
	background: linear-gradient(180deg, #d8f0ff, #c7e8ff) !important;
	box-shadow: inset 0 -1px 0 rgba(25, 159, 255, .18);
}

.freight-info-page ::v-deep .freight-main-table .cell {
	padding-left: 8px;
	padding-right: 8px;
	font-size: 14px;
	line-height: 20px;
}

.freight-info-page ::v-deep .freight-main-table th .cell {
	color: #1f4f6b;
	font-size: 16px;
	font-weight: 900;
	letter-spacing: .5px;
}

.freight-info-page ::v-deep .freight-main-table tbody tr {
	transition: background-color .2s ease, transform .2s ease, box-shadow .2s ease;
}

.freight-info-page ::v-deep .freight-main-table tbody tr:hover > td {
	background-color: #f3faff !important;
}

.freight-info-page ::v-deep .freight-main-table .current-row > td {
	background-color: #eaf7ff !important;
	box-shadow: inset 3px 0 0 #199fff;
}

.freight-info-page ::v-deep .freight-main-table .el-table__body-wrapper::-webkit-scrollbar {
	height: 8px;
	width: 8px;
}

.freight-info-page ::v-deep .freight-main-table .el-table__body-wrapper::-webkit-scrollbar-thumb {
	border-radius: 999px;
	background: linear-gradient(135deg, #b8def2, #a8e9d8);
}

.freight-info-page ::v-deep .freight-main-table .el-table__body-wrapper::-webkit-scrollbar-track {
	border-radius: 999px;
	background: #edf6fb;
}

.freight-info-page ::v-deep .el-table__empty-block {
	min-height: 190px;
}

.freight-info-page ::v-deep .freight-time-column .cell {
	overflow: visible;
	text-overflow: clip;
	white-space: nowrap;
}

.freight-customer-cell,
.freight-progress-cell {
	display: flex;
	flex-direction: column;
	gap: 2px;
}

.freight-primary-text {
	color: #263238;
	font-weight: 700;
	line-height: 19px;
}

.freight-muted-text {
	color: #8ca0ad;
	font-size: 13px;
	line-height: 16px;
}

.freight-route-cell {
	display: flex;
	align-items: center;
	gap: 6px;
	min-width: 0;
	padding: 4px 6px;
	border-radius: 8px;
	white-space: normal;
	transition: background .2s ease, box-shadow .2s ease;
}

.freight-route-cell:hover {
	background: #f0f9ff;
	box-shadow: inset 0 0 0 1px #d7eefb;
}

.freight-route-point {
	min-width: 0;
	color: #2d4656;
	font-weight: 700;
	line-height: 20px;
	white-space: normal;
	word-break: break-all;
}

.freight-route-arrow {
	flex-shrink: 0;
	color: #20b8a0;
	font-weight: 800;
}

.freight-money {
	color: #0f9b72;
	font-weight: 800;
}

.freight-type-tag {
	display: inline-block;
	padding: 2px 8px;
	border-radius: 4px;
	font-size: 12px;
	font-weight: 600;
}

.freight-type-self {
	background: #e8f5e9;
	color: #2e7d32;
}

.freight-type-proxy {
	background: #e3f2fd;
	color: #1565c0;
}

.freight-progress-total {
	color: #2d4656;
	font-weight: 700;
	line-height: 18px;
}

.freight-progress-chips {
	display: flex;
	gap: 6px;
}

.freight-progress-chip {
	display: inline-flex;
	align-items: center;
	height: 20px;
	padding: 0 7px;
	border-radius: 999px;
	font-size: 12px;
	font-weight: 700;
	transition: transform .2s ease, box-shadow .2s ease;
}

.freight-progress-chip:hover {
	box-shadow: 0 6px 12px rgba(34, 90, 132, .1);
	transform: translateY(-1px);
}

.freight-progress-chip.is-done {
	background: #eaf8f2;
	color: #16986f;
}

.freight-progress-chip.is-pending {
	background: #fff5e6;
	color: #d98212;
}

.freight-action-group {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
}

.freight-action-group .el-button {
	min-height: 28px;
	padding: 6px 9px;
	margin: 0 !important;
	border-radius: 999px;
	font-size: 12px;
	font-weight: 700;
	transition: transform .2s ease, box-shadow .2s ease, filter .2s ease;
}

.freight-action-group .el-button:hover,
.freight-action-group .el-button:focus {
	box-shadow: 0 8px 16px rgba(34, 90, 132, .12);
	filter: brightness(1.02);
	transform: translateY(-1px);
}

.freight-action-group .el-button:active {
	box-shadow: none;
	transform: translateY(0);
}

.freight-detail-btn {
	border-color: #d6edff !important;
	background: #eef8ff !important;
}

.freight-cancel-btn {
	border-color: #ffe2b8 !important;
	background: #fff8eb !important;
}

.freight-empty {
	position: relative;
	padding: 42px 0;
	text-align: center;
}

.freight-empty::before {
	content: '';
	display: block;
	width: 54px;
	height: 54px;
	margin: 0 auto 12px;
	border-radius: 18px;
	background:
		linear-gradient(135deg, rgba(25, 159, 255, .16), rgba(32, 218, 156, .18)),
		linear-gradient(180deg, #fff, #f0f9ff);
	box-shadow: inset 0 0 0 1px rgba(25, 159, 255, .14), 0 10px 22px rgba(34, 90, 132, .08);
}

.freight-empty-title {
	color: #415767;
	font-size: 16px;
	font-weight: 800;
}

.freight-empty-desc {
	margin-top: 6px;
	color: #96a7b4;
	font-size: 14px;
}

.freight-pagination {
	margin-top: 14px;
	padding: 12px 12px 0 20px;
	border-top: 1px solid #e5f1f8;
	border-radius: 0 0 12px 12px;
	background: linear-gradient(180deg, rgba(255, 255, 255, 0), rgba(248, 252, 255, .9));
	box-sizing: border-box;
	text-align: right;
}

.freight-info-page ::v-deep .freight-pagination .el-pager li,
.freight-info-page ::v-deep .freight-pagination .btn-prev,
.freight-info-page ::v-deep .freight-pagination .btn-next {
	border-radius: 8px;
	transition: background .2s ease, color .2s ease, box-shadow .2s ease;
}

.freight-info-page ::v-deep .freight-pagination .el-pager li:hover,
.freight-info-page ::v-deep .freight-pagination .btn-prev:hover,
.freight-info-page ::v-deep .freight-pagination .btn-next:hover {
	background: #eaf7ff;
	color: #1685d9;
}

.freight-info-page ::v-deep .freight-pagination .el-pager li.active {
	background: linear-gradient(135deg, #199fff, #20da9c);
	box-shadow: 0 6px 14px rgba(25, 159, 255, .18);
	color: #fff;
}

.freight-detail-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 10px;
}

.freight-detail-grid .DWD-li {
	min-height: 42px;
	height: auto;
	line-height: 20px;
	border: 1px solid #dcecf6;
	border-radius: 10px;
	overflow: hidden;
	background: #fff;
	box-shadow: 0 6px 16px rgba(34, 90, 132, .05);
	transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease;
}

.freight-detail-grid .DWD-li:hover {
	border-color: #bfe2f5;
	box-shadow: 0 10px 20px rgba(34, 90, 132, .08);
	transform: translateY(-1px);
}

.freight-detail-grid .DWD-li + .DWD-li {
	border-top: 1px solid #e3eef5;
}

.freight-detail-grid .DWD-li-title {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 132px;
	border-right: 1px solid #e3eef5;
	background: linear-gradient(180deg, #f2f9ff, #e9f5ff);
	color: #486070;
	font-size: 13px;
	font-weight: 700;
}

.freight-detail-grid .DWD-li-text {
	flex: 1;
	display: flex;
	align-items: center;
	min-width: 0;
	padding: 8px 10px;
	color: #2d3f4c;
	font-size: 13px;
	word-break: break-all;
}

.freight-info-page ::v-deep .el-input__inner {
	border-color: #dcebf4;
	border-radius: 8px;
	transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
}

.freight-info-page ::v-deep .el-input__inner:hover {
	border-color: #b8def2;
	background: #fbfdff;
}

.freight-info-page ::v-deep .el-input__inner:focus {
	border-color: #36aaf2;
	box-shadow: 0 0 0 3px rgba(25, 159, 255, .12);
}

.freight-info-page ::v-deep .el-select:hover .el-input__inner {
	border-color: #9fd6ef;
}

.freight-info-page ::v-deep .el-tooltip__popper.is-light {
	border-color: #c7e4f5;
	box-shadow: 0 8px 20px rgba(34, 90, 132, .12);
	color: #486070;
	font-weight: 700;
}

.freight-info-page ::v-deep .el-table__fixed,
.freight-info-page ::v-deep .el-table__fixed-right {
	box-shadow: 0 0 12px rgba(39, 86, 118, .08);
}

.freight-info-page ::v-deep .el-dialog {
	border: 1px solid rgba(25, 159, 255, .16);
	border-radius: 16px;
	overflow: hidden;
	box-shadow: 0 24px 60px rgba(24, 70, 103, .22);
}

.freight-info-page ::v-deep .el-dialog__header {
	padding: 18px 22px;
	border-bottom: 1px solid #ddecf6;
	background: linear-gradient(135deg, #eaf7ff, #f6fffb);
}

.freight-info-page ::v-deep .el-dialog__title {
	color: #263238;
	font-weight: 700;
}

.freight-info-page ::v-deep .el-dialog__body {
	padding: 20px 22px 22px;
	background: #f7fbfe;
}

.freight-info-page .cancel_content ::v-deep .el-form-item {
	align-items: center;
	margin-bottom: 14px;
}

@media screen and (max-width: 1366px) {
	.freight-filter-fields {
		grid-template-columns: repeat(2, minmax(220px, 1fr));
	}
}

@media screen and (max-width: 768px) {
	.freight-info-page {
		padding: 8px;
	}

	.freight-section-head,
	.freight-table-toolbar {
		align-items: flex-start;
		flex-direction: column;
	}

	.freight-filter-fields,
	.freight-detail-grid {
		grid-template-columns: 1fr;
	}
}

</style>

<style>
.freight-info-dialog {
	border: 1px solid rgba(25, 159, 255, .16);
	border-radius: 16px;
	overflow: hidden;
	box-shadow: 0 24px 60px rgba(24, 70, 103, .22);
}

.freight-info-dialog .el-dialog__header {
	padding: 18px 22px;
	border-bottom: 1px solid #ddecf6;
	background: linear-gradient(135deg, #eaf7ff, #f6fffb);
}

.freight-info-dialog .el-dialog__title {
	color: #263238;
	font-weight: 700;
}

.freight-info-dialog .el-dialog__body {
	padding: 20px 22px 22px;
	background: #f7fbfe;
}
</style>
